export default __webpack_public_path__ + "static/media/greyMagicEdenLogo.a469dd2a.svg";